module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "category"
  }, [_c('h2', [_vm._v(_vm._s(_vm.category.title) + " "), (_vm.category.isPrivate) ? _c('span', {
    staticClass: "members-only"
  }, [_vm._v("Members Only")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.category.forums), function(forum) {
    return (!_vm.editMode) ? _c('forum-item', {
      attrs: {
        "root": _vm.root,
        "category": _vm.category,
        "is-moderator": _vm.isModerator,
        "board-id": _vm.boardId,
        "forum": forum
      }
    }) : _vm._e()
  }), _vm._v(" "), (Object.keys(_vm.category.forums).length === 0 && !_vm.editMode) ? _c('div', {
    staticClass: "no-forums-message"
  }, [_c('div', [_vm._v("No Forums have been created for this Category")])]) : _vm._e(), _vm._v(" "), (_vm.addForumMode) ? _c('div', {
    staticClass: "forum add-forum-form"
  }, [(_vm.addForumSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.addForumSaving) ? _c('div', [(_vm.addForumError) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.addForumError))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForumTitle),
      expression: "addForumTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Forum Title"
    },
    domProps: {
      "value": (_vm.addForumTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addForumTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForumDescription),
      expression: "addForumDescription"
    }],
    attrs: {
      "placeholder": "Forum Description"
    },
    domProps: {
      "value": (_vm.addForumDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addForumDescription = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.addForumMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.addForum
    }
  }, [_vm._v("Add Forum")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('section', {
    staticClass: "edit-category-form"
  }, [(_vm.editCategoryError) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.editCategoryError))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategoryTitle),
      expression: "newCategoryTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Category Title"
    },
    domProps: {
      "value": (_vm.newCategoryTitle)
    },
    on: {
      "focus": function($event) {
        _vm.editCategoryError = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCategoryTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrivate),
      expression: "isPrivate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPrivate) ? _vm._i(_vm.isPrivate, null) > -1 : (_vm.isPrivate)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isPrivate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPrivate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isPrivate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPrivate = $$c
        }
      }
    }
  }), _vm._v(" Members Only Category")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editCategory($event)
      }
    }
  }, [_vm._v("Edit Category")])]) : _vm._e(), _vm._v(" "), (_vm.isModerator && !_vm.editMode && !_vm.addForumMode) ? _c('div', {
    staticClass: "moderator-controls"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.editMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" Edit Category")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.addForumMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" Add a Forum")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17f0fc24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsCategoryItem.vue
// module id = 829
// module chunks = 2